// Canonical "turn an unknown thrown thing into a human string" helper.
//
// The recurring trap (Sentry e3cfcff7, 2026-06-02): code does
// `new Error(serverProvided)` or `String(err)` on a value that is actually a
// plain object — a PostgREST error `{ message, details, hint, code }`, a
// fetched `{ error: '…' }` body, or an edge-function envelope. Both coercions
// yield the literal string "[object Object]", which then renders in the UI
// and lands in client_errors / Sentry with the real reason destroyed.
//
// errorText walks the common shapes (Error, PostgrestError, fetch-Response,
// plain objects with a .message/.error) and only falls through to JSON /
// String as a last resort. Pass a `fallback` for the "nothing useful in
// here" case so callers don't have to special-case null/undefined.
export function errorText(err: unknown, fallback = 'Unknown error'): string {
  if (err == null) return fallback
  if (err instanceof Error) return err.message || fallback
  if (typeof err === 'string') return err || fallback
  if (typeof err === 'object') {
    const o = err as Record<string, unknown>
    if (typeof o.message === 'string' && o.message)             return o.message
    if (typeof o.error_description === 'string' && o.error_description) return o.error_description as string
    if (typeof o.error === 'string' && o.error)                 return o.error as string
    if (typeof o.details === 'string' && o.details)             return o.details as string
    if (typeof o.hint === 'string' && o.hint)                   return o.hint as string
    if (typeof o.statusText === 'string' && o.statusText)       return `HTTP ${o.status ?? '?'} — ${o.statusText}`
    try {
      const j = JSON.stringify(err)
      if (j && j !== '{}') return j.slice(0, 1000)
    } catch { /* circular / non-serialisable — fall through */ }
  }
  return fallback
}
